import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import SearchPage from './pages/SearchPage';
import ProfilePage from './pages/ProfilePage';
import ProviderPage from './pages/ProviderPage';
import DashboardPage from './pages/DashboardPage';
import ClaimPage from './pages/ClaimPage';
import PerksPage from './pages/PerksPage';
import MerchantPage from './pages/MerchantPage';
import PrivateRoute from './components/PrivateRoute';
import StaticPage from './pages/StaticPage';

// MUI Theme
const theme = createTheme({
  breakpoints: {
    values: { xs: 0, sm: 640, md: 1024, lg: 1440, xl: 1920 },
  },
  palette: {
    /* Professional medical palette: deep navy, teal accents, clean surfaces */
    primary: { main: '#0B3B60' },
    secondary: { main: '#0FA3B1' },
    background: { default: '#F7F9FB', paper: '#FFFFFF' },
    text: { primary: '#0A1E2E', secondary: '#516273' },
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: '"Inter", "IBM Plex Sans", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontWeight: 700, letterSpacing: -0.5 },
    h2: { fontWeight: 600, letterSpacing: -0.25 },
    h3: { fontWeight: 600 },
    body1: { fontSize: 16, lineHeight: 1.5 },
    body2: { fontSize: 14, lineHeight: 1.45 },
  },
  components: {
    MuiButton: {
      styleOverrides: { root: { textTransform: 'none', borderRadius: 10 } },
    },
    MuiChip: {
      styleOverrides: { root: { borderRadius: 10, height: 32 } },
    },
    MuiCard: {
      styleOverrides: { root: { borderRadius: 12, boxShadow: '0 8px 24px rgba(10,30,46,0.06)' } },
    },
    MuiAppBar: { styleOverrides: { root: { backgroundColor: '#FFFFFF' } } },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Layout>
            <Routes>
              {/* Public routes */}
              <Route path="/" element={<HomePage />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/:rolePrefix+:username" element={<ProfilePage />} />
              <Route path="/+:username" element={<ProfilePage />} />
              <Route path="/provider/:npi" element={<ProviderPage />} />
              <Route path="/merchants" element={<MerchantPage />} />
              <Route path="/faq" element={<StaticPage title="FAQ" body="Frequently asked questions will appear here." />} />
              <Route path="/privacy" element={<StaticPage title="Privacy Policy" body="Our privacy policy goes here." />} />
              <Route path="/terms" element={<StaticPage title="Terms of Service" body="Terms and conditions go here." />} />
              <Route path="/contact" element={<StaticPage title="Contact" body="Contact us at hello@mdcv.me" />} />

              {/* Protected routes */}
              <Route
                path="/dashboard"
                element={
                  <PrivateRoute>
                    <DashboardPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/claim/:npi"
                element={
                  <PrivateRoute>
                    <ClaimPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/perks"
                element={
                  <PrivateRoute verified>
                    <PerksPage />
                  </PrivateRoute>
                }
              />
            </Routes>
          </Layout>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
